import z from 'zod';
import { createErrorHandler } from './helpers/error-handler';
export const dateTimeValidator = ({ requiredError, }) => {
    return z.iso.datetime({
        error: createErrorHandler(requiredError),
        offset: true,
    });
};
